angular.module("acl.visualizer.promiseCache", []);
